const initialState = {
    calls: [],
}

export default function(state = initialState, action) {
    switch(action.type) {
        case "ADD_OUTGOING_CALL":
            action.payload.data['answered'] = 0;
            return {
                ...state,
                calls: [ ...state.calls, action.payload]
            }
        case "UPDATE_OUTGOING_CALL":
            let updatedCalls = state.calls.map(item => {
                if(item.data.id === action.payload.data.id) {
                    item.data.answered = 1;
                } 
                return item;  
            });
            return {
                ...state, calls: updatedCalls
            }
        case "REMOVE_OUTGOING_CALL":
            return {
                ...state,
                calls: state.calls.filter(item => item.data.id !== action.payload.data.id),
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/browserTabs.js